import { useMemo, useState } from "react"
import useWindowSize from "src/hooks/useWindowSize"
import { isMobileDevice } from "src/util/browser"

function useSizeImage(
  outputs?: {
    width: number
    height: number
  },
  options?: {
    aspectRatio: `${number}/${number}`
  }
) {
  const { width: expectedWidth, height: expectedHeight } = outputs ?? {
    width: null,
    height: null
  }

  const { aspectRatio } = options ?? { aspectRatio: "" }

  const { screenSize } = useWindowSize()
  const isMobile = isMobileDevice(screenSize)

  const { width, height } = screenSize

  const [elWidth, elHeight] = useMemo(() => {
    if (!width || !height) [0, 0] 
    function calcMaxSize() { 

      if (expectedWidth && expectedHeight && aspectRatio) {
        const [w, h] = aspectRatio.split("/").map(parseFloat)
        if (w > h) {
          const ratio = h / w
          return [expectedWidth, (expectedHeight) * ratio]
        } else {
          const ratio = w / h
          return [expectedWidth * ratio, expectedHeight]
        }
      }

      const size = 80
      return [width * (size / 100), height * (size / 100)]
    }

    return calcMaxSize()
  }, [
    isMobile,
    expectedWidth,
    expectedHeight,
    aspectRatio
  ])

  return { width: elWidth, height: elHeight }
}

export default useSizeImage
